<script setup lang="ts">
import { useAuthStore } from "@/stores/auth.module";
import Avatar from "@/stories/media/Avatar/Avatar.vue";
const authStore = useAuthStore();

interface Props {
  isMobile?: boolean;
}

withDefaults(defineProps<Props>(), {
  isMobile: false,
});
</script>

<template>
  <div class="mb-[20px] hidden pr-4 gap-2 justify-start desktop:flex">
    <Avatar
      :src="authStore.profile?.image?.source"
      :alt="authStore.profile?.displayName || authStore.profile?.email || ''"
      :size="30"
    />

    <div>
      <p class="b100">{{ $t("global.loggedInAs") }}</p>
      <p class="h50 w-full truncate">
        {{ authStore.profile?.email }}
      </p>
    </div>
  </div>
</template>
